import { forwardRef, Fragment } from "react";
import { cn } from "../../../shared/utils";
import PropTypes from "prop-types";

// eslint-disable-next-line react/display-name
const TextareaInput = forwardRef(
    (
        {
            name,
            value,
            handleChange,
            rows = 1,
            cols = 50,
            label,
            customStyles = "",
            inputStyles = "",
            disabled = false,
        },
        ref,
    ) => {
        return (
            <Fragment>
                <label htmlFor={name} className={cn("ecotic-label", disabled ? "opacity-50" : "", customStyles)}>
                    {label}
                </label>
                <textarea
                    name={name}
                    id={name}
                    value={value || ""}
                    placeholder={label}
                    onChange={handleChange}
                    rows={rows}
                    cols={cols}
                    ref={ref}
                    disabled={disabled}
                    className={cn("ecotic-textarea text-center resize-none", inputStyles)}
                />
            </Fragment>
        );
    },
);

TextareaInput.propTypes = {
    rows: PropTypes.number,
    cols: PropTypes.number,
    disabled: PropTypes.bool,
    inputStyles: PropTypes.string,
    customStyles: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TextareaInput;
